import { Stack, Text } from 'braid-design-system';
import { BrandSelect } from 'wingman-fe';

import type { HiringOrganizationIdFieldsFragment } from '#src/types/generated/graphql.ts';
import { SectionHeadingLink } from './SectionHeadingLink/SectionHeadingLink.tsx';

interface Props {
  hirer?: HiringOrganizationIdFieldsFragment;
}

export const BrandingSection = ({ hirer }: Props) => (
  <Stack space="large">
    <SectionHeadingLink href="/use-cases/job-posting/branding">
      Brand select
    </SectionHeadingLink>

    {hirer ? (
      <BrandSelect hideLabel hirerId={hirer.id.value} showCopyableOid />
    ) : (
      <Text tone="secondary">Select a hirer to view their brands.</Text>
    )}
  </Stack>
);
